let vacancy_completion_forms = (function( $ ) {

	let $radio;

	var _init = function() {
		$radio = $( 'input[name="purchase_type"]' );

		if ( $radio.length > 0 ) {
			$radio.on( 'change', _change_event );
		}
	};

	var _change_event = function( e ) {
		var form = $( this ).val();

		$( '.completion-form-wrapper' ).removeClass( 'active' );
		$( '.completion-form-wrapper.' + form ).addClass( 'active' );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = vacancy_completion_forms;